import React from 'react';
import LocalizedStaticPage from './LocalizedStaticPage';

const MobileDownload = () => <LocalizedStaticPage page="mobile" />;
export default MobileDownload;
